module.exports = __webpack_public_path__ + "static/media/help.fcc3ea5a.svg";